import { ListenerArgs, ListenerEvent, ListenerFunction } from "./types";

export class Pubsub {
  private _events: { [key: ListenerEvent]: ListenerFunction[] } = {};

  on(event: ListenerEvent, listener: ListenerFunction): () => void {
    if (!this._events[event]) {
      this._events[event] = [];
    }

    this._events[event].push(listener);

    return () => {
      this._events[event] = this._events[event].filter(fn => fn !== listener);
    };
  }

  publish(event: ListenerEvent, ...args: ListenerArgs): void {
    if (!this._events[event]) {
      return;
    }

    this._events[event].forEach(listener => {
      listener(...args);
    });
  }
}
